// What a customer credit on the Money tab says it came from (credits.list's origin), in the office's
// words.

const ORIGIN: Record<string, string> = {
  overpayment: 'Paid over what was owed',
  unapplied_payment: 'A payment with no invoice',
  credit_note: 'A credit note',
  dispute_won: 'Back from a won card dispute',
  deposit: 'A deposit on a sold estimate', // BL-006: taken off the invoice when the work is done
  membership_cancel: 'A cancelled membership’s unused part', // BL-056: one brought over from ServiceTitan
};

/**
 * A credit's source. A membership's cancel reads the same whichever way it was refunded: a credit
 * note on a sale made here, or from deferred revenue for one brought over (QA-646).
 */
export function creditWord(c: { origin: string; membershipCancel?: boolean }): string {
  if (c.membershipCancel) return ORIGIN['membership_cancel']!;
  return ORIGIN[c.origin] ?? c.origin.replace(/_/g, ' ').replace(/^./, (x) => x.toUpperCase());
}
